var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVaccinationWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.91426 17.8359L5.14989 19.0141L6.32877 19.2499L4.70711 20.8715C4.31658 21.262 3.68342 21.262 3.29289 20.8715C2.90237 20.481 2.90237 19.8478 3.29289 19.4573L4.91426 17.8359Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7066 4.45696C11.3161 4.06643 10.6829 4.06643 10.2924 4.45696C9.90188 4.84748 9.90188 5.48065 10.2924 5.87117L10.5854 6.16412L5.80634 10.9431C4.62422 12.1253 4.11111 13.8199 4.43897 15.4592L5.14989 19.0138L8.70444 19.7247C10.3437 20.0526 12.0384 19.5395 13.2206 18.3573L17.9996 13.5783L18.2924 13.8712C18.6829 14.2617 19.3161 14.2617 19.7066 13.8712C20.0971 13.4806 20.0971 12.8475 19.7066 12.457L11.7066 4.45696Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7071 12.457C13.3166 12.0664 12.6834 12.0664 12.2929 12.457C11.9024 12.8475 11.9024 13.4806 12.2929 13.8712L13.2929 14.8712C13.6834 15.2617 14.3166 15.2617 14.7071 14.8712C15.0976 14.4806 15.0976 13.8475 14.7071 13.457L13.7071 12.457ZM11.2071 14.957C10.8166 14.5664 10.1834 14.5664 9.79289 14.957C9.40237 15.3475 9.40237 15.9806 9.79289 16.3712L10.7929 17.3712C11.1834 17.7617 11.8166 17.7617 12.2071 17.3712C12.5976 16.9806 12.5976 16.3475 12.2071 15.957L11.2071 14.957Z",
    fill: "#A461D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2931 3.45696C15.6837 3.06643 16.3168 3.06643 16.7074 3.45696L20.7074 7.45696C21.0979 7.84748 21.0979 8.48065 20.7074 8.87117C20.3168 9.26169 19.6837 9.26169 19.2931 8.87117L18.0002 7.57828L16.4142 9.16431L15 7.75009L16.586 6.16406L15.2931 4.87117C14.9026 4.48065 14.9026 3.84748 15.2931 3.45696Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaccinationWhite);
export default __webpack_public_path__ + "static/media/vaccination-white.aaf84c4e8e4ec76d4b064ee35dcffae7.svg";
export { ForwardRef as ReactComponent };